/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-pointer-color',
  templateUrl: './theme-option-elements-chart-gauge-pointer-color.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-pointer-color.component.css']
})
export class ThemeOptionElementsChartGaugePointerColorComponent  {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_pointer_color';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption(this.optionType, value);
  }

}
